import Alpine from 'alpinejs';

Alpine.store('state', {
	current: 'default',
	next: null,
	states: [
		'default',
		'nav-open',
		'search-open'
	],
	direction: 1, // 1 or -1
	toggle( next ) {

		// just go back to default state
		// eg. toggle close nav or search
		if( this.current == next ){
			this.next = 'default';
			this.direction = -1;
			return;
		}
		
		// for swapping between animation on search-open to nav-open
		if( this.current !== 'default' ){
			this.next = next;
			this.direction = next == 'search-open' ? 1 : -1;
			return;
		}

		this.next = next;
		this.direction = 1;

	}
});

// Alpine.start();